import { useQuery } from "@tanstack/react-query";
import {
  getInternalCompanyRecommendations,
  searchInternalCompanies,
} from "apis/internalCompany";

// Rekomendasi perusahaan dari kontak meeting (per app). Butuh appId & contactId.
export function useInternalCompanyRecommendations(appId, contactId, options = {}) {
  return useQuery({
    queryKey: ["internalCompanyRecommendations", appId, contactId],
    queryFn: () =>
      getInternalCompanyRecommendations({ app_id: appId, contact_id: contactId }),
    enabled: appId != null && contactId != null,
    select: (res) => res.data.data,
    ...options,
  });
}

// Cari perusahaan internal by nama (per app). Butuh appId & q (≥ 1 char).
export function useSearchInternalCompanies(appId, q, options = {}) {
  return useQuery({
    queryKey: ["internalCompanySearch", appId, q],
    queryFn: () => searchInternalCompanies({ app_id: appId, q }),
    enabled: appId != null && !!q && q.length >= 1,
    select: (res) => res.data.data,
    ...options,
  });
}
